// @ts-expect-error untyped
import config from 'quartz-config-loader?{"forApp":true}!';
export default config;